import { useTranslation } from "@impero-com/common/utils/i18n";
import { Modal } from "@impero-com/ui";

import { CommentField } from "components/modals/CommentField";
import { Content } from "components/modals/Content";
import { Footer } from "components/modals/Footer";
import { useModalComment } from "components/modals/useModalComment";

interface ControlActivityArchiveModalProps {
    open: boolean;
    loading: boolean;
    onConfirm: (comment: string) => void;
    onClose: () => void;
}

export function ControlActivityArchiveModal({
    open,
    loading,
    onConfirm,
    onClose,
}: ControlActivityArchiveModalProps) {
    const { t } = useTranslation();
    const { comment, setComment, trimmed, isValid, isTooLong } =
        useModalComment({
            open,
        });

    return (
        <Modal
            variant="content"
            open={open}
            footer={
                <Footer
                    onClose={onClose}
                    onConfirm={() => onConfirm(trimmed)}
                    confirmLabel={t("Archive")}
                    loading={loading}
                    okDisabled={!isValid}
                />
            }
            onClose={onClose}
            title={t("ControlResult_Archive_ConfirmTitle")}
        >
            <Content body={t("ControlResult_Archive_ConfirmBody")}>
                <CommentField
                    value={comment}
                    onChange={setComment}
                    label={t("ControlResult_Archive_ConfirmComment")}
                    placeholder={t("ControlResult_Archive_ConfirmPlaceholder")}
                    error={
                        isTooLong ? t("ControlResult_Comment_Error") : undefined
                    }
                />
            </Content>
        </Modal>
    );
}
